exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "movimiento-fraccionado-form .row>h4{margin-bottom:20px;margin-top:20px}movimiento-fraccionado-form .meta-data div.col-lg-4{text-align:center}movimiento-fraccionado-form .mbottom-20{margin-bottom:20px}movimiento-fraccionado-form .dataTable-static.table>thead>tr>th{background-color:#fbfbfb}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/movimientos-fraccionados/form/form.scss
// module id = 1293
// module chunks = 0